export default __webpack_public_path__ + "static/media/segment.1da50467.svg";